
import React from 'react';

import './CardAuth.scss';
import { LanguageSelect } from '../language/select';
import logo from "../../../assets/logo.png"
import { appInfo } from '../../../app-info';

type SingleCardProps = {
  title?: string;
  description?: string;
};

export const CardAuth = ({ title, description, children }: React.PropsWithChildren<SingleCardProps>) => {
  return (
    <div className='auth-card'>
      <div className='dx-card content'>
        <div className='header'>
          <div className='flex w-full text-center justify-center items-center'>
          <img src={logo} className='w-64'></img>
          </div>
        </div>
        <div className='flex justify-between py-3'>
          <div className='flex mt-2 text-xxs font-bold text-[#0062b0]'>Version {appInfo().version}</div>
        <div className='flex '><LanguageSelect/></div>

        </div>

        {children}
      </div>
    </div>
  );
};
